export default __webpack_public_path__ + "static/media/K0002.f48151be.png";